import { render, staticRenderFns } from "./upgradeModal.vue?vue&type=template&id=487ab071"
import script from "./upgradeModal.vue?vue&type=script&lang=js"
export * from "./upgradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports